import React from 'react'
import MenuService from 'live/services/menu'
import Router from 'live/services/router'
import i18n from 'live/services/i18n'
import locale from 'live/init/global-locale'
import pt_br from './i18n/pt_br'
import en_us from './i18n/en_us'
import ExtensionService from "live/services/extension"
import Form from './form'
import CameraView from './components/CameraView/index'
import VehiclesList from './components/VehiclesList'
var localeFiles = {
    pt_br: pt_br,
    en_us: en_us
}
i18n.add(localeFiles[locale])

Router.route('cameras', VehiclesList, 'cameras')
Router.route('camera-view', CameraView, 'camera-view')
Router.route('camera-view/{id}', CameraView, 'camera-view')
MenuService.register(
    {
        alias: 'cameras',
        name: i18n('Cameras'),
        url: '/#/cameras/',
        selectedAliases: ['cameras']
    },
    'regular'
)


ExtensionService.register({
    name:  "Cameras",
    type: "plugin-cameras",
    description: "Integrate your cameras with Eyeride",
    icon: "/content/plugin-cameras/eyeride.jpg",
    ui: {
        form: Form,
        view: null,
    }


})